module.exports = {
  "country": "IE",
  "artist": "Linda Martin",
  "song": "Why Me?",
  "year": "1992",
  "place": "1",
  "spotify": "3Y81Q8dLI74Mgi1wbXvscv"
};